var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.residence
    ? _c(
        "div",
        { attrs: { itemscope: "", itemtype: "http://schema.org/Product" } },
        [
          _c(
            "div",
            { staticClass: "c-top-nav-container" },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "c-btn c-btn--primary c-btn--margins c-btn--has-icon",
                  attrs: { to: "/" },
                },
                [
                  _c("icon-left", {
                    staticClass:
                      "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                  }),
                  _vm._v("\n      Oversikt\n    "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasOptions === true &&
          _vm.residence.availability.slug === "for-sale"
            ? _c(
                "section",
                {
                  staticClass: "l-detailspage l-detailspage--options",
                  class: {
                    "l-detailspage--options-nomedia":
                      _vm.residence.images.length === 0,
                    "l-detailspage--options-media":
                      _vm.residence.images.length > 0,
                  },
                },
                [
                  _c("section", { staticClass: "c-infosection" }, [
                    _c(
                      "div",
                      { staticClass: "c-infosection__container" },
                      [
                        _c("Illustration", {
                          staticClass: "l-detailspage__media",
                          attrs: {
                            images: _vm.residence.images,
                            residence_id: _vm.residence.id,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "h1",
                          { staticClass: "u-h2", attrs: { itemprop: "name" } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.residence.name) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.hasLoadedAllData
                          ? _c("Factlist", {
                              attrs: {
                                id: _vm.residence.id,
                                residencetype_id:
                                  _vm.residence.residencetype_id,
                              },
                            })
                          : _c("spinner"),
                        _vm._v(" "),
                        _vm.residence.images.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "c-btn c-btn--primary c-btn--margins",
                                on: {
                                  click: _vm.toggleModal,
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.toggleModal($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          Se større plantegninger\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showLargeIllustrations &&
                        _vm.residence.images.length > 0
                          ? _c(
                              "modal-illustration",
                              { on: { close: _vm.toggleLargeIllustrations } },
                              [
                                _c("Illustration", {
                                  attrs: { residence_id: _vm.residence.id },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.files, function (file) {
                          return _c("LinkButton", {
                            key: file.id,
                            attrs: {
                              label: file.title,
                              url: file.url,
                              "button-type": "secondary",
                            },
                          })
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.links, function (link) {
                          return _c("LinkButton", {
                            key: link.id,
                            attrs: {
                              label: link.label,
                              url: link.url,
                              "button-type": "tertiary",
                              linkTarget: "_blank",
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("h2", [_vm._v("Tilpass boligen")]),
                      _vm._v(" "),
                      _vm._l(_vm.OptionCategory, function (category) {
                        return _c("category-section", {
                          key: category.id,
                          attrs: {
                            categoryId: category.id,
                            residenceId: _vm.residence.id,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c("price-info", {
                        attrs: { residenceId: _vm.residence.id },
                      }),
                      _vm._v(" "),
                      _vm.hasCalculator && _vm.hasLoadedAllData
                        ? _c("Calculator", {
                            attrs: { residenceId: _vm.residence.id },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasContactForm && _vm.hasLoadedAllData
                        ? _c("contact-form", {
                            attrs: { residenceId: _vm.residence.id },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _c(
                "section",
                {
                  staticClass: "l-detailspage",
                  class: {
                    "l-detailspage--nomedia": _vm.residence.images.length === 0,
                    "l-detailspage--media": _vm.residence.images.length > 0,
                  },
                },
                [
                  _c(
                    "header",
                    {
                      staticClass:
                        "l-detailspage__header u-border-bottom u-margin-bottom-small",
                    },
                    [
                      _c("meta", {
                        attrs: { property: "og:type", content: "product" },
                      }),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: {
                          property: "og:title",
                          content: _vm.residence.name,
                        },
                      }),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: { property: "og:url", content: _vm.ogUrl },
                      }),
                      _vm._v(" "),
                      _vm.residence.images.length > 0
                        ? _c("meta", {
                            attrs: {
                              property: "og:image",
                              content: _vm.residence.images[0].url,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: {
                          property: "og:description",
                          content: _vm.residence.description,
                        },
                      }),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: {
                          property: "product:price.amount",
                          content: _vm.residence.totalPrice,
                        },
                      }),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: {
                          property: "product:price.currency",
                          content: "NOK",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "h1",
                        { staticClass: "u-h2 u-margin-bottom-none u-split" },
                        [
                          _c("span", { attrs: { itemprop: "name" } }, [
                            _vm._v(_vm._s(_vm.residence.name)),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.priceInfo))]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              attrs: {
                                itemprop: "offers",
                                itemscope: "",
                                itemtype: "http://schema.org/Offer",
                              },
                            },
                            [
                              _vm.residence.availability.slug === "for-sale"
                                ? _c("span", {
                                    attrs: {
                                      itemprop: "availability",
                                      content: "https://schema.org/InStock",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", {
                                attrs: {
                                  itemprop: "price",
                                  content: _vm.residence.totalPrice,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                attrs: {
                                  itemprop: "priceCurrency",
                                  content: "NOK",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("Illustration", {
                    staticClass: "l-detailspage__media",
                    attrs: {
                      images: _vm.residence.images,
                      residence_id: _vm.residence.id,
                      itemprop: "image",
                    },
                    on: {
                      open: function ($event) {
                        return _vm.openLargeIllustrationsFromIllustrations()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "l-detailspage__content" },
                    [
                      _vm.residence.description
                        ? _c("p", { staticClass: "u-push-bottom" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.residence.description) +
                                "\n      "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasLoadedAllData
                        ? _c("Factlist", {
                            attrs: {
                              id: _vm.residence.id,
                              residencetype_id: _vm.residence.residencetype_id,
                            },
                          })
                        : _c("spinner", { staticClass: "c-spinner--page" }),
                      _vm._v(" "),
                      _vm.residence.facilities.length > 0
                        ? _c("Facilities", {
                            attrs: { facilities: _vm.residence.facilities },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.residence.longDescription
                        ? _c("section", { staticClass: "u-push-bottom" }, [
                            _c("h3", [_vm._v("Beskrivelse")]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.residence.longDescription
                                ),
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.residence.images.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "c-btn c-btn--primary c-btn--margins u-push-bottom",
                              on: {
                                click: _vm.openLargeIllustrationsFromButton,
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.openLargeIllustrationsFromButton(
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        Se større plantegninger\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showLargeIllustrations &&
                      _vm.residence.images.length > 0
                        ? _c(
                            "modal-illustration",
                            { on: { close: _vm.toggleLargeIllustrations } },
                            [
                              _c("Illustration", {
                                attrs: { residence_id: _vm.residence.id },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.files, function (file) {
                        return _c("LinkButton", {
                          key: file.id,
                          attrs: {
                            label: file.title,
                            url: file.url,
                            "button-type": "secondary",
                            linkTarget: "_blank",
                            download: "",
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.links, function (link) {
                        return _c("LinkButton", {
                          key: link.id,
                          attrs: {
                            label: link.label,
                            url: link.url,
                            "button-type": "tertiary",
                            linkTarget: "_blank",
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm.hasCalculator && _vm.hasLoadedAllData
                        ? _c("h3", { staticClass: "u-push-top" }, [
                            _vm._v("\n        Lånekalkulator\n      "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasCalculator && _vm.hasLoadedAllData
                        ? _c("Calculator", {
                            attrs: { residenceId: _vm.residence.id },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasContactForm && _vm.hasLoadedAllData
                        ? _c("contact-form", {
                            attrs: { residenceId: _vm.residence.id },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
        ]
      )
    : _c("div", { staticClass: "u-text-center" }, [
        _c("h2", [_vm._v("Finnes ikke")]),
        _vm._v(" "),
        _c("p", [_vm._v("Nå har du kommet til en side som ikke finnes.")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "unavailable__list" },
          [
            _c(
              "router-link",
              {
                staticClass: "c-btn c-btn--primary c-btn--has-icon",
                attrs: { to: "/" },
              },
              [
                _c("icon-left", {
                  staticClass:
                    "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                }),
                _vm._v("\n      Gå tilbake til oversikten\n    "),
              ],
              1
            ),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }